/* eslint-disable array-callback-return */
import { useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { ColumnDefinitionType } from '../../components/UIelements/GenericTable/genericTableTypes';
import GenericTable from '../../components/UIelements/GenericTable';
import * as Styled from './styles';
import PrimaryButton from '../../components/FormElements/PrimaryButton';
import { loadSerialNumbers } from '../../services';
import Loading from '../../components/Loading';

const columns: ColumnDefinitionType<
  any,
  keyof any
>[] = [
    {
      key: 'serialNumber',
      gridArea: 'title',
      header: 'equipment.Número de série',
      isSortable: false,
      width: '24%',
    },
    {
      key: 'model',
      gridArea: 'data1',
      header: 'company.Modelo',
      isSortable: false,
      width: '22%',
    },
    {
      key: 'creationDate',
      gridArea: 'data4',
      header: 'company.Cadastro',
      isSortable: false,
      width: '22%',
    },
    {
      key: 'conect',
      gridArea: 'data6',
      header: 'company.Conectado',
      isSortable: false,
      width: '22%',
    },
    {
      key: 'edit',
      gridArea: 'data3',
      header: ' ',
      isSortable: false,
      width: '2%',
    },
    {
      key: 'delete',
      gridArea: 'data7',
      header: ' ',
      isSortable: false,
      width: '2%',
    }
  ];

type ModalProps = {
  serialNumbers: any[]
  serialNumberCheck: number[]
  idCompany: string
  accessToken: string
  selectSerialNumber: (value: number) => void
  showModalDeleteSerialNumber: () => void
  showModalUpdateSerialNUmber: () => void
  selectedMarker: (value: Array<number>) => void
};

const TableSerialNumbers: React.FC<ModalProps> = ({
  serialNumbers,
  idCompany,
  accessToken,
  selectSerialNumber,
  serialNumberCheck,
  showModalDeleteSerialNumber,
  showModalUpdateSerialNUmber,
  selectedMarker }) => {
  const intl = useIntl();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedMarkerList, setSelectedMarkerList] = useState<Array<number>>([]);
  const [columnOrder, setColumnOrder] = '';
  useState<keyof any>('id');


  const getFormattedList = (
    equipmentList: any[],
    columnOrder: keyof any,
    intl: ReturnType<typeof useIntl>
  ): any[] => {
    const orderedList = [...equipmentList].sort((a, b) => {
      switch (columnOrder) {
        case 'name':
          return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
        default:
          return a.id > b.id ? 1 : a.id < b.id ? -1 : 0;
      }
    });

    const formattedList = orderedList.map(equipment => {
      const formattedEquipment = { ...equipment };
      return formattedEquipment;
    });

    return formattedList;
  };

  const formattedEquipmentList = getFormattedList(
    serialNumbers,
    columnOrder,
    intl
  );

  const handleOrderTable = useCallback(
    (columnName: keyof any) => {

    },
    []
  );

  const handleVisibleMarkers = useCallback(async (id: number, isChecked: boolean) => {
    if (id === 0 && isChecked) {
      setIsLoading(true)
      const resp = await loadSerialNumbers(idCompany, accessToken ?? '');
      const serialNUmbers = resp.data.SerialNumbers ?? []
      setIsLoading(false)
      setSelectedMarkerList([0, ...serialNUmbers.map((obj: { id: number }) => obj.id)])

    } else if (id === 0 && !isChecked) {
      setSelectedMarkerList([])
    } else {
      setSelectedMarkerList((prevState) =>
        isChecked
          ? prevState.includes(id)
            ? prevState
            : [...prevState, id]
          : prevState.filter((value) => value !== id)
      );
    }

    selectedMarker(selectedMarkerList)
  }, []);

  useEffect(() => {
    selectedMarker(selectedMarkerList)
  }, [selectedMarkerList]);

  const handleClick = (id: number, typeOptions?: string) => {
    selectSerialNumber(id)
    if (typeOptions === "delete") {
      setSelectedMarkerList([])
      showModalDeleteSerialNumber()
    }
    else
      showModalUpdateSerialNUmber()
  };

  return (
    <>
      {isLoading && <Loading />}
      {!isLoading && (
        <GenericTable
          className='serialNumbers-table'
          data={formattedEquipmentList}
          columns={columns}
          clickUpdate={handleClick}
          onOrderTable={handleOrderTable}
          showMobileHeaders
          checkboxAll={true}
          checkbox={{
            show: true,
            action: handleVisibleMarkers,
            selectedList: serialNumberCheck
          }}
        />
      )}

      {selectedMarkerList.length ?
        <>
          <Styled.InfoDelete>
            {intl.formatMessage({ id: 'company.SELECIONE EQUIPAMENTOS PARA EXCLUIR' })}
          </Styled.InfoDelete>
          <Styled.DivButton className='optionButtons'>
            <PrimaryButton type='button' size='buttonModal' model='confirmation-gradient-modal' width='108px' onClick={() => showModalDeleteSerialNumber()}>
              {intl.formatMessage({ id: 'menus.Excluir' })}
            </PrimaryButton>
            <PrimaryButton type='button' size='buttonModal' model='cancellation' width='108px' onClick={() => setSelectedMarkerList([])}>
              {intl.formatMessage({ id: 'menus.CANCELAR' })}
            </PrimaryButton>
          </Styled.DivButton>
        </>
        :
        <></>
      }
    </>

  )
}

export default TableSerialNumbers
